import {
  Injectable,
} from '@angular/core'
import {
  Locale, UserLocaleService,
} from './user-locale.service'

declare interface Navigator {
  languages: string[]
}
declare const navigator: Navigator

@Injectable({
  providedIn: 'root',
})
export class UserLocaleBrowserService implements UserLocaleService {
  private cachedUserLocales?: Locale[]

  public getUserLocales(): Locale[] {
    if (this.cachedUserLocales) {
      return this.cachedUserLocales
    }

    const browserLocales = navigator.languages

    const locales = browserLocales.map((locale) => {
      const [language, region] = locale.split('-')
      return {
        language,
        region,
      }
    })

    // Fill all missing regions with the first region found
    const firstLocaleWithRegion = locales.find(locale => locale.region !== undefined)
    if (firstLocaleWithRegion !== undefined) {
      locales.filter(locale => locale.region === undefined).forEach(locale => locale.region = firstLocaleWithRegion.region)
    }

    this.cachedUserLocales = locales
    return this.cachedUserLocales
  }

  public getPrimaryRegion(): string | undefined {
    return this.getUserLocales()[0]?.region
  }

  public getPrimaryLanguage(): string | undefined {
    return this.getUserLocales()[0]?.language
  }
}
